import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "#D4262A"
}), React.createElement("path", {
  d: "M17.3778 6.72205L6.78857 17.3113",
  stroke: "white",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M6.78857 6.72205L17.3778 17.3113",
  stroke: "white",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
})), "IconMessageError");